/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.52458.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class EmailVerificationControllerApi extends runtime.BaseAPI {
    /**
     * Delete all validation requests
     */
    async deleteAllValidationRequestsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/email-verification`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete all validation requests
     */
    async deleteAllValidationRequests(initOverrides) {
        await this.deleteAllValidationRequestsRaw(initOverrides);
    }
    /**
     * Delete a validation record
     */
    async deleteValidationRequestRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteValidationRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/email-verification/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a validation record
     */
    async deleteValidationRequest(requestParameters, initOverrides) {
        await this.deleteValidationRequestRaw(requestParameters, initOverrides);
    }
    /**
     * Validate a list of email addresses. Per unit billing. See your plan for pricing.
     */
    async getValidationRequestsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        if (requestParameters.isValid !== undefined) {
            queryParameters['isValid'] = requestParameters.isValid;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/email-verification/validation-requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Validate a list of email addresses. Per unit billing. See your plan for pricing.
     */
    async getValidationRequests(requestParameters = {}, initOverrides) {
        const response = await this.getValidationRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Validate a list of email addresses. Per unit billing. See your plan for pricing.
     */
    async validateEmailAddressListRaw(requestParameters, initOverrides) {
        if (requestParameters.validateEmailAddressListOptions === null || requestParameters.validateEmailAddressListOptions === undefined) {
            throw new runtime.RequiredError('validateEmailAddressListOptions', 'Required parameter requestParameters.validateEmailAddressListOptions was null or undefined when calling validateEmailAddressList.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/email-verification/email-address-list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.validateEmailAddressListOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Validate a list of email addresses. Per unit billing. See your plan for pricing.
     */
    async validateEmailAddressList(requestParameters, initOverrides) {
        const response = await this.validateEmailAddressListRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetValidationRequestsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
